export default {
    "visits-count": "عدد الزيارات",
    "view-chart": "عرض المخططات البيانية",
    "visit-details": "تفاصيل الزيارة",
    "distributed-materials": "المواد الموزعة",
    "materials": "المواد",
    "quantity": "الكمية",
    "other-materials": "مواد أخرى",
    "duration-in-minutes": "المدة بالدقائق",
    "core-message": "الرسالة الأساسية",
    "notes": "الملاحظات",
    "objections": "الاعتراضات",
    "next-call": "الاتصال التالي",
    "unavailable-products": "المواد الغير متوفرة",
    "competitors": "المنافسين",
    "center-notes": "ملاحظات المركز",
    "sort-by-classification": "الترتيب بحسب التصنيف",
    "sort-by-name": "الترتيب بحسب الاسم",
    // tabs: {
    //     all: "الكل",
    //     "doctor-visits": "زيارات الأطباء",
    //     "pharmacy-visits": "زيارات الصيدليات",
    //     "center-visits": "زيارات المركز"
    // },
    "samples": "المواد",
    "add-visit": "إضافة زيارة",
    'view-visit': 'عرض الزيارة'
}